import React, { useContext } from 'react'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import List from '@mui/material/List'
import ListSubheader from '@mui/material/ListSubheader'
import ListItem from '@mui/material/ListItem'
import Menu from '@mui/material/Menu'
import SettingsIcon from '@mui/icons-material/Settings'
import Button from '@mui/material/Button'
import RoutedDropdownSelect from '../../../components/RoutedDropdownSelect'
import { CurveType } from '@mui/x-charts/models'
import { UserMeContext } from '../../../../contexts/UserMeContext'

export const seriesDropdownItems = [
    {
        id: 'closePrice',
        label: 'Stängningskurs',
    },
    {
        id: 'vwap',
        label: 'VWAP',
    },
    {
        id: 'marketcap',
        label: 'Börsvärde',
    },
    {
        id: 'numberOfShares',
        label: 'Antal aktier',
    },
] as const

export const TradesGraphToolbar = ({
    defaultSerie,
    onChangeCurveType,
    selectedCurveType,
}: {
    defaultSerie: (typeof seriesDropdownItems)[number]['id']
    onChangeCurveType: (curveType: CurveType) => void
    selectedCurveType: CurveType
}) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const handleToggleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const { updateMe } = useContext(UserMeContext)
    const graphRoutingParam = 'serie'

    const handleChangeSerie = (serie: (typeof seriesDropdownItems)[number]['id']) => {
        updateMe({ settings: { tradesGraph: { serie } } }).catch((err) => console.error(err))
    }

    const handleToggleCurveType = () => {
        const curveType = selectedCurveType === 'monotoneX' ? 'linear' : 'monotoneX'
        onChangeCurveType(curveType)
        updateMe({ settings: { tradesGraph: { curveType } } }).catch((err) => console.error(err))
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <Button
                id='settings-button'
                aria-haspopup='listbox'
                aria-controls='settings-menu'
                aria-label='Inställningar'
                aria-expanded={anchorEl ? 'true' : undefined}
                onClick={handleToggleMenu}
                sx={{ position: 'absolute', top: -5, right: 1 }}
            >
                <SettingsIcon />
            </Button>
            <Menu
                id='settings-menu'
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                slotProps={{
                    list: {
                        'aria-labelledby': 'settings-button',
                        role: 'listbox',
                    },
                }}
            >
                <List
                    sx={{ width: '100%', minWidth: 200, maxWidth: 560, bgcolor: 'background.paper', borderRadius: 4 }}
                    subheader={<ListSubheader>Inställningar</ListSubheader>}
                >
                    <ListItem>
                        <FormControl>
                            <RoutedDropdownSelect
                                defaultItem={defaultSerie}
                                items={seriesDropdownItems}
                                label='Välj serie'
                                onChange={handleChangeSerie}
                                routingParam={graphRoutingParam}
                            />
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <FormControlLabel
                            control={
                                <Switch checked={selectedCurveType === 'monotoneX'} onChange={handleToggleCurveType} />
                            }
                            label='Mjuk linjegraf'
                        />
                    </ListItem>
                </List>
            </Menu>
        </>
    )
}
